import { useInfiniteQuery } from '@tanstack/react-query';

import { QueryConfig } from '@/lib/react-query';
import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';
import { ParamsWithPagination } from '@/types/api';

import { getClips } from './get-clips';
import { clipsQueryKeys } from './query-keys';

type QueryFnType = typeof getClips;

interface UseClipParams {
  config?: QueryConfig<QueryFnType>;
  filters?: Partial<ProgramBroadcastFiltersState>;
  params?: ParamsWithPagination<unknown>;
}

export function useInfiniteClips({ params, filters }: UseClipParams = {}) {
  return useInfiniteQuery({
    queryKey: clipsQueryKeys.infiniteList(filters),
    queryFn: ({ pageParam = 0 }) =>
      getClips({ filters, params: { ...params, offset: pageParam, limit: 25 } }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.length === 25 ? allPages.flat().length : undefined,
  });
}
